import { WidgetApiService } from "./widgetApiService";
import { DictionariesStore } from "../../stores/dictionariesStore";


export interface DictionariesService {
    refreshBanks: () => void;
    refreshPaymentMethods: () => void;
}

export class DefaultDictionariesService {

    constructor(private dictionariesStore: DictionariesStore, private widgetApiSrvc: WidgetApiService) {}

    refreshBanks() {
        this.widgetApiSrvc.banks()
            .then((result) => {
                this.dictionariesStore.setBanks(result.data);
            }).catch((failiure) => {
                // tslint:disable-next-line:no-console
                console.log("Error fetching banks: "+failiure.message);
            });
    }

    refreshPaymentMethods() {
        this.widgetApiSrvc.paymentMethods()
            .then((result) => {
                this.dictionariesStore.setPaymentMethods(result.data);
            }).catch((failiure) => {
                // tslint:disable-next-line:no-console
                console.log("Error fetching payment methods: "+failiure.message);
            });
    }

}